"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("./models");
var engine_1 = require("./engine");
exports.metricComparisonForPoint = function (table, currentValue, comparison) {
    var comparisonPoints = exports.generateDataPointsWithComparison(table, [currentValue], comparison);
    var point = comparisonPoints[comparisonPoints.length - 1];
    if (!point) {
        return undefined;
    }
    return exports.computeMetricComparison(point);
};
exports.generateDataPointsWithComparison = function (table, windowedTable, comparison) {
    if (!comparison || isNoComparison(comparison)) {
        return windowedTable;
    }
    var comparisonPoints = generateComparisonPoints(comparison, table, windowedTable);
    return interleaveComparisonPoints(windowedTable, comparisonPoints);
};
var generateComparisonPoints = function (comparison, table, windowedTable) {
    var unit = engine_1.momentStringFromDateTrunc(comparison.compareTo);
    if (isMarkBasedComparison(comparison) || !unit) {
        return generateMarkBasedComparison(table, windowedTable);
    }
    else {
        var currentRange = engine_1.getDateRange(windowedTable);
        if (!currentRange) {
            return windowedTable;
        }
        return generateTimeBasedComparison(table, comparison, unit, currentRange);
    }
};
var generateMarkBasedComparison = function (table, windowedTable) {
    if (windowedTable.length === 0) {
        return windowedTable;
    }
    var windowLastPoint = windowedTable[windowedTable.length - 1];
    var windowFirstPoint = windowedTable[0];
    // offset the window's points by 1 to get the window 1 mark prior
    var comparisonLastIndex = findIndexOfPoint(table, windowLastPoint) - 1;
    var comparisonFirstIndex = findIndexOfPoint(table, windowFirstPoint) - 1;
    return comparisonPointsForPriorMark(table, comparisonFirstIndex, comparisonLastIndex);
};
var comparisonPointsForPriorMark = function (table, comparisonFirstIndex, comparisonLastIndex) {
    var comparisonPoints = [];
    for (var index = comparisonFirstIndex; index <= comparisonLastIndex; index++) {
        if (index > -1) {
            var timestamp = table[index + 1].timestamp;
            var point = table[index];
            comparisonPoints.push({
                comparison: point,
                timestamp: timestamp
            });
        }
    }
    return comparisonPoints;
};
var DEFAULT_NUMBER_OF_PERIODS = 1;
var generateTimeBasedComparison = function (table, comparison, unit, currentRange) {
    var amount = comparison.numberOfPeriods || DEFAULT_NUMBER_OF_PERIODS;
    return comparisonPointsForRange(currentRange, amount, unit, table);
};
var findIndexOfPoint = function (table, point) {
    return table.findIndex(function (value) { return atSameTime(value, point) && value.measure === point.measure; });
};
var comparisonPointsForRange = function (currentRange, amount, unit, table) {
    var comparisonRange = exports.rangeBefore(currentRange, amount, unit);
    var comparisonPoints = [];
    table.forEach(function (point) {
        if (engine_1.withinRange(comparisonRange, point.timestamp)) {
            var timestamp = engine_1.dateAfter(point.timestamp, amount, unit);
            comparisonPoints.push({
                comparison: point,
                timestamp: timestamp
            });
        }
    });
    return comparisonPoints;
};
var interleaveComparisonPoints = function (windowedTable, comparisonPoints) {
    // The current index in the comparison array.
    // Since the data is sorted, we can walk the array down to keep up with 'data'.
    var comparisonIndex = 0;
    var dataPointsWithComparison = [];
    windowedTable.forEach(function (dp) {
        while (comparisonIndex < comparisonPoints.length && isBefore(comparisonPoints[comparisonIndex], dp)) {
            // Comparison Point with No Matching point in original table
            var comparisonPoint = comparisonPoints[comparisonIndex];
            comparisonIndex++;
            dataPointsWithComparison.push(comparisonPoint);
        }
        if (comparisonIndex < comparisonPoints.length && atSameTime(dp, comparisonPoints[comparisonIndex])) {
            // comparison point with matching point in original table
            var comparisonPoint = comparisonPoints[comparisonIndex];
            comparisonIndex++;
            dataPointsWithComparison.push(mergePoints(dp, comparisonPoint));
        }
        else {
            // point in original table with no matching comparison point
            dataPointsWithComparison.push(dp);
        }
    });
    return dataPointsWithComparison;
};
var atSameTime = function (originalPoint, comparisonPoint) {
    return originalPoint.timestamp.getTime() === comparisonPoint.timestamp.getTime();
};
var isBefore = function (comparisonPoint, originalPoint) {
    return comparisonPoint.timestamp < originalPoint.timestamp;
};
var mergePoints = function (originalPoint, comparisonPoint) {
    return {
        measure: originalPoint.measure,
        timestamp: originalPoint.timestamp,
        comparison: comparisonPoint.comparison
    };
};
exports.rangeBefore = function (currentRange, amount, unit) {
    var firstComparison = engine_1.dateBefore(currentRange.first, amount, unit);
    var lastComparison = engine_1.dateBefore(currentRange.last, amount, unit);
    return { first: firstComparison, last: lastComparison };
};
var isNoComparison = function (comparison) {
    return comparison.compareTo === models_1.DateTrunc.NONE;
};
var isMarkBasedComparison = function (comparison) {
    return comparison.compareTo === models_1.DateTrunc.UNKNOWN;
};
exports.renderablePoints = function (input) { return input.filter(function (p) { return p.measure !== undefined; }); };
// To render points on a VictoryLine, we need meaure and timestamp to represent y and x,
// respectively. This returns the comparison point's measure and the translated timestamp
// to align the comparison measure on the x axis within the current line's domain
exports.renderableComparisonPoints = function (input) {
    return input.filter(function (p) { return p.comparison !== undefined; })
        .map(function (p) { var _a; return ({ measure: (_a = p.comparison) === null || _a === void 0 ? void 0 : _a.measure, timestamp: p.timestamp }); });
};
exports.computeMetricComparison = function (point) {
    if (point.measure === undefined || point.comparison === undefined) {
        return undefined;
    }
    var absolute = point.measure - point.comparison.measure;
    var percentage = absolute === 0 ? 0 : (absolute / point.comparison.measure);
    return {
        absolute: absolute,
        percentage: percentage,
        comparedPoint: point.comparison,
    };
};
//# sourceMappingURL=comparisonEngine.js.map